import { render, staticRenderFns } from "./UpgradeDropdown.vue?vue&type=template&id=3b9acbe8&"
import script from "./UpgradeDropdown.vue?vue&type=script&lang=js&"
export * from "./UpgradeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports